/* @flow */
import { ActionTypes } from 'constants/RoleVerificationConstants';
import { dispatcher } from 'lib/Dispatcher';

const RoleVerificationActions = {
  addRoleVerification(roleVerification: Object) {
    dispatcher.dispatch({
      type: ActionTypes.ROLE_VERIFICATION_LOADED,
      roleVerification,
    });
  },
};

export default RoleVerificationActions;



// WEBPACK FOOTER //
// ./src/actions/RoleVerificationActions.js